import React from "react";
import { formatMoney } from "../utils/format";

const summaryStyles = {
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "5px",
    padding: "3px 0",
  },
  subSummmaryItem: {
    fontSize: '14px',
    color: 'gray',
    marginLeft: '5px',
  },
  subtotalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    fontWeight: "bold",
  },
};

const Summary = ({ summary, appliedDiscount }) => (
  <div style={summaryStyles.summary}>
    <h3 style={{ fontWeight: "1.1rem", paddingBottom: 10 }}>Summary</h3>
    <div style={summaryStyles.summaryRow}>
      <span>Items</span>
      <span style={{ borderBottom: appliedDiscount?.discount ? "" : "1px solid #b3b3b3", paddingLeft: 15 }}>
        {summary && summary.itemTotal !== undefined ? formatMoney(summary.itemTotal) : ''}
      </span>
    </div>
    {appliedDiscount && (
      <div style={summaryStyles.summaryRow}>
        <span>Promotion ({appliedDiscount.percentage}% off)</span>
        <span style={{ borderBottom: appliedDiscount.discount ? "1px solid #b3b3b3" : "" }}>
          - {formatMoney(appliedDiscount.discountAmount)}
        </span>
      </div>
    )}
    <div style={summaryStyles.summaryRow}>
      <span>Subtotal:</span>
      <span>{summary && summary.subtotal !== undefined ? formatMoney(summary.subtotal) : ''}</span>
    </div>
    <div style={summaryStyles.summaryRow}>
      <span>Shipping:</span>
      <span style={{ borderBottom: summary && summary.perishableAmount > 0 ? "" : "1px solid #b3b3b3", paddingLeft: 15 }}>
        {summary && summary.calculatedShippingCost !== undefined ? formatMoney(summary.calculatedShippingCost) : ''}
      </span>
    </div>
    {summary && summary.perishableAmount > 0 && (
      <div style={{ ...summaryStyles.summaryRow }}>
        <span style={summaryStyles.subSummmaryItem}> + Cold Shipping Fee:</span>
        <span style={{ borderBottom: "1px solid #b3b3b3", paddingLeft: 15 }}>
          {formatMoney(summary.perishableAmount)}
        </span>
      </div>
    )}
    {summary && summary.paymentTotals && summary.paymentTotals.wallet > 0 && (
      <div style={summaryStyles.summaryRow}>
        <span>Wallet Deduction:</span>
        <span>- {formatMoney(summary.paymentTotals.wallet)}</span>
      </div>
    )}
    <div style={summaryStyles.subtotalRow}>
      <span>Total:</span>
      <span style={summaryStyles.summaryRow}>{summary && summary.paymentTotals ? formatMoney(summary.paymentTotals.cc) : ''}</span>
    </div>
  </div>
);

export default Summary;
